<template>
  <div class="common-page order-management">
    <div class="top-box">
      <div class="search-form-box">
        <el-row :gutter="30">
          <el-form inline>
            <el-col :span="5">
              <el-form-item label="货主来源:" prop="promotionType">
                <el-select
                  style="width: 100%"
                  v-model="searchForm.promotionType"
                  filterable
                  default-first-option
                  clearable
                  placeholder="请选择">
                  <el-option
                    v-for="item in $dict.promotionTypeOptions"
                    :key="item.dictCode"
                    :label="item.dictLabel"
                    :value="item.dictCode"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="货主归属:" prop="companyId">
                <el-select
                  style="width: 100%"
                  v-model="searchForm.companyId"
                  filterable
                  allow-create
                  default-first-option
                  clearable
                  placeholder="请选择">
                  <el-option
                    v-for="item in companyData"
                    :key="item.companyId"
                    :label="item.companyName"
                    :value="item.companyId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="货主名称:">
                <el-input
                  style="width: 100%"
                  clearable
                  v-model="searchForm.username"
                  autocomplete="off"
                  placeholder="请输入" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="货主联系方式:">
                <el-input
                  style="width: 100%"
                  clearable
                  v-model="searchForm.phone"
                  autocomplete="off"
                  placeholder="请输入" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="存在有效订单:">
                <el-select
                  style="width: 100%"
                  v-model="searchForm.hasValidOrder"
                  default-first-option
                  clearable
                  placeholder="请选择">
                  <el-option label="是" :value="true"></el-option>
                  <el-option label="否" :value="false"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="注册时间:">
                <custom-date-range
                  :start-date="searchForm.registerStartTime"
                  :end-date="searchForm.registerEndTime"
                  @update:startDate="
                    (val) => (searchForm.registerStartTime = val)
                  "
                  @update:endDate="(val) => (searchForm.registerEndTime = val)"></custom-date-range>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="">
                <el-button type="primary" round icon="el-icon-search" @click="handleCheck()"></el-button>
                <el-button type="default" round icon="el-icon-refresh" @click="handleReset()"></el-button>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
      </div>
      <div class="statistics-box">
        <div class="statistics-list">
          <el-image :src="statisticsImage1" class="statistics-image"></el-image>
          <div class="statistics-num">
            <div class="num">{{ overviewData.ownerNum }}</div>
            <div class="txt">货主总量</div>
          </div>
        </div>
        <div class="statistics-list">
          <el-image :src="statisticsImage2" class="statistics-image"></el-image>
          <div class="statistics-num">
            <div class="num">{{ overviewData.validOwnerNum }}</div>
            <div class="txt">有效货主</div>
          </div>
        </div>
        <div class="statistics-list">
          <el-image :src="statisticsImage3" class="statistics-image"></el-image>
          <div class="statistics-num">
            <div class="num">{{ overviewData.orderNum }}</div>
            <div class="txt">下单笔数</div>
          </div>
        </div>
        <div class="statistics-list">
          <el-image :src="statisticsImage4" class="statistics-image"></el-image>
          <div class="statistics-num">
            <div class="num">{{ overviewData.completeOrderNum }}</div>
            <div class="txt">订单完成数</div>
          </div>
        </div>
        <div class="statistics-list">
          <el-image :src="statisticsImage5" class="statistics-image"></el-image>
          <div class="statistics-num">
            <div class="num">￥{{ overviewData.totalAmount }}</div>
            <div class="txt">累计订单金额</div>
          </div>
        </div>
      </div>
    </div>

    <div class="custom-table-box">
      <custom-table
        :data="tableData"
        :column="tableColumn"
        :total="tableOptions.total"
        :loading="tableOptions.loading"
        :page="tableOptions.pageNumber"
        :size="tableOptions.pageSize"
        :selection="false"
        @pagination="handleSizeChange">
        <template v-slot:totalOrderNum="{ row }">{{ row.totalOrderNum }}/{{ row.completeOrderNum }}</template>
        <template v-slot:completeAmount="{ row }">￥{{ row.completeAmount }}</template>
        <template v-slot:operation="{ row }">
          <span class="operate-btn" @click="updateCustomer(row)">修改客户归属</span>
        </template>
      </custom-table>
    </div>

    <!--    添加或编辑-->
    <addOrEdit :company-data="companyData" ref="addOrEdit"></addOrEdit>
  </div>
</template>

<script>
import OperateBox from "@/components/OperateBox.vue";
import CustomTable from "@/components/CustomTable.vue";
import CustomDateRange from "@/components/CustomDateRange.vue";
import addOrEdit from "./addOrEdit.vue";
import { getOwnerOverview, getPage } from "./api";
import tableMixin from "@/mixin/tableMixin";

export default {
  name: "ShipperManagement",
  mixins: [tableMixin],
  components: {
    OperateBox,
    CustomTable,
    CustomDateRange,
    addOrEdit,
  },
  data() {
    return {
      getTableMethod: getPage,
      haveCompany: true,
      searchForm: {
        companyId: "",
        hasValidOrder: "",
        phone: "",
        promotionType: "",
        registerEndTime: "",
        registerStartTime: "",
        username: "",
      },
      overviewData: {},
      isImmediatelyGetData: true,
      tableColumn: [
        {
          label: "货主名称",
          prop: "username",
          align: "left",
          show: true,
        },
        {
          label: "货主手机号码",
          prop: "phone",
          align: "left",
          show: true,
        },
        {
          label: "下单/订单完成(笔)",
          prop: "totalOrderNum",
          scopeStatus: true,
          align: "left",
          show: true,
        },
        {
          label: "货主归属",
          prop: "companyName",
          align: "left",
          show: true,
        },
        {
          label: "累计完成金额",
          prop: "completeAmount",
          scopeStatus: true,
          align: "left",
          show: true,
        },
        {
          label: "最后下单时间",
          prop: "lastOrderTime",
          align: "left",
          show: true,
        },
        {
          label: "注册时间",
          prop: "registerTime",
          align: "left",
          show: true,
        },
        {
          label: "操作",
          prop: "operation",
          fixed: "right",
          width: "160px",
          scopeStatus: true,
          show: true,
        },
      ],
      statisticsImage1: require("@/assets/imgs/huozhuzongliang.png"),
      statisticsImage2: require("@/assets/imgs/youxiaohuozhu.png"),
      statisticsImage3: require("@/assets/imgs/xiadanbishu.png"),
      statisticsImage4: require("@/assets/imgs/dingdanwancheng.png"),
      statisticsImage5: require("@/assets/imgs/leijijine.png"),
    };
  },
  created() {
    this.getAllData();
  },
  mounted() {},
  methods: {
    handleCheck() {
      this.getAllData();
      this.getTableData();
    },
    getAllData() {
      getOwnerOverview({
        companyId: this.searchForm.companyId,
        hasValidOrder: this.searchForm.hasValidOrder,
        phone: this.searchForm.phone,
        promotionType: this.searchForm.promotionType,
        registerEndTime: this.searchForm.registerEndTime,
        registerStartTime: this.searchForm.registerStartTime,
        username: this.searchForm.username,
      }).then((res) => {
        if (res.code === 200) {
          this.overviewData = res.data;
        }
      });
    },
    updateCustomer(row) {
      this.$refs.addOrEdit.init(row);
    },
  },
};
</script>
<style lang="scss" scoped>
.order-management {
  .search-form-title {
    font-weight: 400;
    font-size: 0.16rem;
    color: #111827;
    line-height: 0.24rem;
    padding-bottom: 0.08rem;
  }

  .drop-image {
    width: 0.24rem;
    height: 0.24rem;
  }

  .owner-requirement {
    background-color: rgba(217, 236, 255, 0.5);
    color: #1269ff;
    padding: 0.05rem;
    border-radius: 0.06rem;
  }

  .mileage {
    position: relative;
    padding: 0 0.05rem 0.06rem;
  }

  .mileage::after {
    content: "→";
    position: absolute;
    left: 0;
    bottom: -0.06rem;
    text-align: center;
    width: 100%;
  }
  .statistics-box {
    display: flex;
    justify-content: space-around;
    padding: 0 0.16rem;
    margin: 0 -0.1rem;
    .statistics-list {
      width: 33.33%;
      height: 1.2rem;
      background-color: #ffffff;
      border-radius: 0.08rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0.2rem;
      box-sizing: border-box;
      margin: 0 0.1rem;
      .statistics-image {
        width: 0.8rem;
        height: 0.61rem;
      }
      .statistics-num {
        .num {
          font-size: 0.24rem;
          color: #000000;
          font-weight: bold;
        }
        .txt {
          font-size: 0.14rem;
          color: #434343;
          padding-top: 0.1rem;
        }
      }
    }
  }
}
</style>
